import { FC, PropsWithChildren, useEffect } from 'react';
import { Flex } from 'antd';
import { Header, Sidemenu } from '../';
import useHttpService from '../../services/hook';
import { RequestMethods } from '../../services/enum';
import { useAppDispatch, useAppSelector } from '../../store';
import { userActions } from '../../store/reducers/userReducer';
import { IUserInfo } from '../../store/reducers/userReducer/type';
import Logo from '../../assets/images/logo-dark.svg';
import { IRolePermissions } from './type';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();
  const executeService = useHttpService();

  const { role } = useAppSelector((state) => state.userReducer.userInfo);
  const isSpinnerVisible = useAppSelector(
    (state) => state.layoutReducer.isSpinnerVisible,
  );

  const handleFetchUserInfo = async () => {
    const response = await executeService<IUserInfo>({
      method: RequestMethods.GET,
      url: 'auth/user/me/',
    });
    if (response && 'id' in response) {
      dispatch(userActions.changeUserInfo(response));
    }
  };

  const handleFetchUserPermissions = async () => {
    const response = await executeService<IRolePermissions>({
      method: RequestMethods.GET,
      url: `auth/role/${role.id}/`,
    });
    if (response && 'id' in response) {
      dispatch(userActions.changeUserPermissions(response.permissions));
    }
  };

  useEffect(() => {
    handleFetchUserInfo();
  }, []);

  useEffect(() => {
    role?.id && handleFetchUserPermissions();
  }, [role?.id]);

  return (
    <div>
      <Header />
      <Flex style={{ width: '100%', overflowY: 'hidden' }}>
        <Sidemenu />
        {isSpinnerVisible ? (
          <div
            style={{
              position: 'fixed',
              zIndex: 9999,
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(255,255,255,0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={Logo} alt="Loading..." />
          </div>
        ) : null}
        <Flex justify="center" style={{ width: '100%' }}>
          {children}
        </Flex>
      </Flex>
    </div>
  );
};

export default Layout;
